import { Injector, NgModule } from '@angular/core';

import { epicObs } from '../store';

import { Mi2Service } from './core';
import { CmpsMi2MainModule, mainEpics } from './main';
import { CmpsFLMi2MainModule } from './main-frontline';
import { setModuleInjector } from './mi2.metadata';
import { CmpsMi2PopulationGroupDialogModule } from './population-group-dialog';
import { CmpsMi2TrendDialogModule } from './trend-dialog';

@NgModule({
    exports: [CmpsMi2MainModule, CmpsFLMi2MainModule],
    imports: [
        CmpsMi2PopulationGroupDialogModule,
        CmpsMi2TrendDialogModule,
        CmpsMi2MainModule,
        CmpsFLMi2MainModule,
    ],
    providers: [Mi2Service],
})
export class CmpsMi2Module {
    constructor(private readonly _injector: Injector) {
        setModuleInjector(_injector);
        mainEpics.forEach((e) => epicObs.next(e));
    }
}
